import { render, staticRenderFns } from "./AddModalGestionarDespacho.vue?vue&type=template&id=c76895a2&"
import script from "./AddModalGestionarDespacho.vue?vue&type=script&lang=ts&"
export * from "./AddModalGestionarDespacho.vue?vue&type=script&lang=ts&"
import style0 from "./AddModalGestionarDespacho.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports